import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { selectHasLoadError, selectIsLoadingProject } from '@ff-os/pdp-shared-redux/slices/projectLoadingSlice';
import { Alert } from '@ff-os/shared-react/components/alert/Alert';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { WindowStackProvider } from '@ff-os/shared-react/context/window-stack/WindowStack';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { setIsGiftWindowOpen } from './_redux-ui';
import { GiftWindowStackItem } from './display-window/GiftWindowStackItem';
import { ArQrCodeStackItem } from './preview/ArQrCodeStackItem';

const _GiftModalUi = ({
    isLoadingProject, hasLoadError,
    setIsOpen
}: Props) => {

    const { t } = useTranslation();

    return (
        <WindowStackProvider>
            <Grid gap='s' direction='column'>

                {hasLoadError && (
                    <Cell>
                        <Alert icon='alert-triangle-exclamation' type='error'>
                            {t('load_project.error_message')}
                        </Alert>
                    </Cell>
                )}

                {!isLoadingProject && (
                    <GiftWindowStackItem setIsOpen={setIsOpen} />
                )}
            </Grid>

            <ArQrCodeStackItem />
        </WindowStackProvider>
    );
};

type Props = {
    isLoadingProject: boolean;
    hasLoadError: boolean;
    setIsOpen: (value: boolean) => void;
};

const mapStateToProps = (state: GiftPdpState) => ({
    isLoadingProject: selectIsLoadingProject(state),
    hasLoadError: selectHasLoadError(state)
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch) => ({
    setIsOpen: (value: boolean) => dispatch(setIsGiftWindowOpen(value))
});

export const GiftModalUi = connect(
    mapStateToProps,
    mapDispatchToProps
)(_GiftModalUi);